

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_PaginationCore";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_PaginationCore__root","button-common-mixin":"wds_1_76_1_PaginationCore__button-common-mixin","navButton":"wds_1_76_1_PaginationCore__navButton","emptyButton":"wds_1_76_1_PaginationCore__emptyButton","navButtonFirst":"wds_1_76_1_PaginationCore__navButtonFirst","navButtonPrevious":"wds_1_76_1_PaginationCore__navButtonPrevious","emptyButtonPrevious":"wds_1_76_1_PaginationCore__emptyButtonPrevious","navButtonNext":"wds_1_76_1_PaginationCore__navButtonNext","emptyButtonNext":"wds_1_76_1_PaginationCore__emptyButtonNext","navButtonLast":"wds_1_76_1_PaginationCore__navButtonLast","pageStrip":"wds_1_76_1_PaginationCore__pageStrip","pageStripInner":"wds_1_76_1_PaginationCore__pageStripInner","pageStripTemplate":"wds_1_76_1_PaginationCore__pageStripTemplate","pageButton":"wds_1_76_1_PaginationCore__pageButton","currentPage":"wds_1_76_1_PaginationCore__currentPage","gap":"wds_1_76_1_PaginationCore__gap","pageForm":"wds_1_76_1_PaginationCore__pageForm","compact":"wds_1_76_1_PaginationCore__compact wds_1_76_1_PaginationCore__pageForm","pageInput":"wds_1_76_1_PaginationCore__pageInput","totalPages":"wds_1_76_1_PaginationCore__totalPages","slash":"wds_1_76_1_PaginationCore__slash"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




